import type { ReactNode } from 'react';

import { type btnType, TypeButton } from '../../components/reusable/button';
import { Hvc } from '../../components/reusable/components';

export interface RightPanelStatusComponentCTA {
	title: string;
	onClick: () => void;
	buttonType?: btnType;
}
export interface IRightPanelStatusComponentProps {
	view: boolean;
	response: {
		title?: string;
		description?: string;
	};
	children?: ReactNode;
	ctas?: RightPanelStatusComponentCTA[];
	onClose: () => void;
}

const RightPanelStatusComponent = ({ view, response, children, ctas, onClose }: IRightPanelStatusComponentProps) => {
	const title = response?.title;
	const description = response?.description;

	return (
		<Hvc
			removeDOM
			view={view}
			className='f-column-10 text-center border rounded p-5'
		>
			{!!title && <h2>{title}</h2>}

			{!!description && <p className='mb-5'>{description}</p>}

			{children}

			<div className='f-column-33 justify-content-center align-items-center'>
				{ctas?.map((cta) => (
					<TypeButton
						title={cta.title}
						buttonSize='small'
						buttonType={cta.buttonType}
						onClick={cta.onClick}
						className='w-100'
						key={cta.title}
					/>
				))}

				<TypeButton
					title='Close'
					buttonType='danger'
					onClick={onClose}
					buttonSize='small'
					className='hw-mx border-0'
				/>
			</div>
		</Hvc>
	);
};

export default RightPanelStatusComponent;
